var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-page',{style:('background-image:url(' +
    require('@/assets/img/hero03.png') +
    '); background-size:cover;')},[_c('section-frame',{attrs:{"title":"Shops","subTitle":"お取扱店舗"}},[_c('shop-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }